import PropTypes from 'prop-types';
import { Sku } from '../../domain/models/Sku';
import { DashboardSkuGroup } from '../../domain/models/DashboardSkuGroup';
import { Sku as LibSku } from '@movivendor/mv-components';

const adaptLocalSkuToLib = (localSku: Sku): LibSku => ({
  sku: localSku.sku,
  skuName: localSku.skuName,
  logoPath: localSku.logoPath,
});

export const ButtonDashboardGroupSku = ({ data, onOpenSaleModal }: any) => {
  const handleGroupClick = () => {
    if (onOpenSaleModal) {
      const libOptions = data.skus?.map((sku: Sku) => adaptLocalSkuToLib(sku));
      onOpenSaleModal(undefined, data.groupName, libOptions);
    }
  };

  const handleSkuShortcutClick = (sku: Sku) => {
    const libSku = adaptLocalSkuToLib(sku);
    if (onOpenSaleModal) {
      onOpenSaleModal(libSku, data.groupName);
    }
  };


  return (
    <>
      <div className="row cardNeu p-3 mt-3 ml-3 mr-3 mb-3 d-flex overflow-auto">
        <div className="col-md-5 mt-2 mb-2 align-items-left">
          <div style={{ cursor: 'pointer' }} onClick={handleGroupClick}>
            <div>
              <button onFocus={(e: any) => e.target.blur()} type="button" className='btn btn-0 text-left'><h4 className="lventa pointer colorPrimary">{data.groupName}</h4></button>
            </div>
            <div>
              <button type='button' onFocus={(e: any) => e.target.blur()} className='colorTextSecondary btn btn-0 text-left'><small>{data.groupSubtitle}</small></button>
            </div>
          </div>
        </div>
        <div className="col-md-7 d-flex iconosLogos mb-4">
          {data.shortcuts.map((sku: Sku) => (
            <div
              key={sku.sku}
              className='col text-center d-flex flex-column align-items-center justify-content-between pointer'
              style={{
                cursor: 'pointer',
                height: '50px',
              }}
              onClick={() => handleSkuShortcutClick(sku)}
            >
              <div
                className="logo-container"
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth:'70px',
                  maxHeight: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  padding: '0.25em',
                  marginRight: '0.10em',
                  marginLeft: '0.10em'
                }}
              >
                <img
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    
                  }}
                  src={sku.logoPath}
                  alt={sku.skuName}
                />
              </div>
              <p
                className='lbventa text-center colorTextPrimary'
                style={{
                  lineHeight: '1.2',
                  fontSize: '13px',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '5x' // Altura mínima para el texto
                }}
              >
                <small>{sku.skuName}</small>
              </p>
            </div>
          ))}
        </div>
      </div >
    </>
  );
}
ButtonDashboardGroupSku.propTypes = {
  data: PropTypes.instanceOf(DashboardSkuGroup),
  onOpenSaleModal: PropTypes.func
}